import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import { TextField, FormControl, InputLabel, Select, MenuItem, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@material-ui/core'
import { EditorState, convertToRaw } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { Spin, Icon } from 'antd';

const initialState = {
    input: {
        title: '',
        content: EditorState.createEmpty(),
				is_active: true,
    },
    dialogOpen: false,
    loading: false
}

class AddAnnouncementDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'AddAnnouncementDialog')
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset() {
        this.setState({ input: initialState.input })
    }

    OpenDialog() {
        this.reset()
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({
            dialogOpen: false,
            loading: false
        })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    antIcon() {
        return <Icon type="loading" style={{ fontSize: 18 }} spin />
    }


    render() {
        return (
            <Dialog open={this.state.dialogOpen}>
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        label={this.t('title')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.input.title}
                        onChange={(event) =>
                            this.setState({
                                input: {
                                    ...this.state.input,
                                    title: event.target.value,
                                },
                            })
                        }
                        margin="dense"
                        fullWidth
                    />
					<FormControl margin="dense" fullWidth>
						<InputLabel>{this.t('isActive')}</InputLabel>
						<Select
							value={this.state.input.is_active}
							onChange={(event) =>
								this.setState({
									input: {
										...this.state.input,
										is_active: event.target.value,
									},
								})
							}>
							<MenuItem value={true}>{this.t('enable')}</MenuItem>
							<MenuItem value={false}>{this.t('disable')}</MenuItem>
						</Select>
					</FormControl>
                    <Editor
                        editorState={this.state.input.content}
                        onEditorStateChange={(editorState) => {
                            this.setState({
                                input: {
                                    ...this.state.input,
                                    content: editorState,
                                },
                            })
                        }}
                        toolbar={{
                            inline: { inDropdown: true },
                            list: { inDropdown: true },
                            textAlign: { inDropdown: true },
                            link: { inDropdown: true },
                            history: { inDropdown: true },
                            colorPicker: {
                                popupClassName: this.props.classes.colorPickerPopup,
                            },
                        }}
                        toolbarClassName={this.props.classes.editorToolbar}
                        wrapperClassName={this.props.classes.editorWrapper}
                        editorClassName={this.props.classes.editorEditor}
                    />
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.setState({loading: true})
                            // Extract content text from EditorState
                            const blocks = convertToRaw(this.state.input.content.getCurrentContent()).blocks
                            const editorText = blocks.map((block) => (!block.text.trim() && '\n') || block.text).join('  ')

                            utils.apiRequest(
                                'post',
                                API.ANNOUNCEMENT,
                                {
                                    ...this.state.input,
                                    content: JSON.stringify(convertToRaw(this.state.input.content.getCurrentContent())),
                                    content_brief: editorText.substring(0, 40) + (editorText.length > 40 ? ' ...' : ''),
                                },
                                (_data) => {
                                    this.setState({loading: false})
                                    this.confirm()
                                },
                                (_err) => {
                                    this.setState({loading: false})
                                }
                            )
                        }}
                        disabled={this.state.loading}
                        color="primary">
                        {this.state.loading && <Spin indicator={this.antIcon()} className={this.props.classes.loadingIcon} />}
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        editorToolbar: {
            border: 'solid 1px',
            margin: '12px 0',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        editorWrapper: {},
        editorEditor: {
            height: '300px',
            padding: '0 14px',
            border: 'solid 1px',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        colorPickerPopup: {
            left: 'auto',
            right: '5px',
        },
        loadingIcon: {
            marginRight: _theme.spacing(1),
            color: '#fff',
            lineHeight: 1
        },

    }
}

AddAnnouncementDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(AddAnnouncementDialog)
